export const queryBuilder =(object) => {
  const keys = Object.keys(object);
	const query = keys.reduce((existing, currentKey) => existing + '&' + currentKey + '=' + object[currentKey], '?');
	return query;
}